import React from "react";
import { getUnavailabilityOn, getQuotaOn } from "../utils/availability";

const name = (emp) => `${emp.prenom || ""}${emp.nom ? ` ${emp.nom}` : ""}`.trim();

const CHIP = {
  ON_LEAVE: { cls: "bg-amber-200 text-amber-900", icon: "🌴", label: "EN CONGÉS" },
  FULL: { cls: "bg-red-200 text-red-900", icon: "🚫", label: "FULL" },
  QUOTA: { cls: "bg-blue-100 text-blue-900", icon: "⚡" },
};

/**
 * Bandeau d'un jour : uniquement les employés indisponibles ou limités (congés, FULL, quota).
 */
export const DayAvailability = ({ employees, dateStr }) => {
  const limited = employees
    .map((emp) => {
      const p = getUnavailabilityOn(emp, dateStr);
      if (p) return { emp, type: p.type };
      const quota = getQuotaOn(emp, dateStr);
      return quota ? { emp, type: "QUOTA", quota } : null;
    })
    .filter(Boolean);
  if (limited.length === 0) return null;

  return (
    <div
      className="bg-slate-50 border-b border-slate-200 px-3 py-1.5 text-xs flex flex-wrap items-center gap-1.5"
      data-testid={`absents-banner-${dateStr}`}
    >
      <span className="font-semibold text-amber-800">⚠️ Indisponible{limited.length > 1 ? "s" : ""} / limité{limited.length > 1 ? "s" : ""} :</span>
      {limited.map(({ emp, type, quota }) => {
        const c = CHIP[type];
        return (
          <span
            key={emp.id}
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full font-semibold ${c.cls}`}
            data-testid={`day-unavailable-${dateStr}-${emp.id}`}
          >
            {c.icon} {name(emp)}
            <span className="opacity-70">({type === "QUOTA" ? `Max ${quota}/j` : c.label})</span>
          </span>
        );
      })}
    </div>
  );
};

export default DayAvailability;
